import styled from 'styled-components'

export const StyledControlsWrapper = styled.div<{ isFadeIn }>`
  display: flex;
  background: linear-gradient(180deg, rgba(19, 19, 19, 0) 0%, rgba(0, 0, 0, 0.7) 49.98%);

  position: absolute;
  bottom: 0;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  box-sizing: border-box;
  cursor: default;
  opacity: ${(props) => (props.isFadeIn ? 1 : 0)};
  transition: opacity 0.5s;
`

export const StyledControls = styled.div`
  display: flex;
  align-items: center;
`

export const StyledButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const StyledVideoTitle = styled.div`
  color: white;
  background-color: transparent;
  font-size: 14px;
  line-height: 24.2px;
  text-align: left;
`
